module.exports = __webpack_public_path__ + "img/source-sans-pro-v21-latin-600.1cf138a8.svg";